module.exports = __webpack_public_path__ + "static/media/berlin.7a4b04bc.jpeg";